/**
 * Partner Embed Configuration
 *
 * These values are set dynamically based on URL parameters and environment variables.
 */

// API URLs
export const API_URL = import.meta.env.VITE_API_URL || '';
export const CUSTOMER_API_URL = import.meta.env.VITE_API_URL || '';

// These will be set dynamically from URL params or context
// The shared components reference these, so we provide mutable exports
let _partnerId: string | undefined;
let _productTag: string | undefined;
let _productName: string | undefined;
let _productPriceCents: number = 0;

export const getPartnerId = () => _partnerId;
export const setPartnerId = (id: string | undefined) => {
  _partnerId = id;
};

export const getProductTag = () => _productTag;
export const setProductTag = (tag: string | undefined) => {
  _productTag = tag;
};

export const getProductName = () => _productName;
export const setProductName = (name: string | undefined) => {
  _productName = name;
};

export const getProductPriceCents = () => _productPriceCents;
export const setProductPriceCents = (cents: number) => {
  _productPriceCents = cents;
};

// Static exports for shared components (will be overridden by setters)
export const PARTNER_ID = undefined; // Set dynamically
export const SHOPIFY_PRODUCT_TAG = ''; // Set dynamically
export const SHOPIFY_PRODUCT_NAME = ''; // Set dynamically
export const SHOPIFY_PRODUCT_PRICE_CENTS = 0; // Set dynamically
